import { SetupIntroductionStep } from "@/components/setup/setup-introduction-step";

export const SetupResubscriptionIntroductionPage = () => (
  <SetupIntroductionStep translationPrefix="setup.resubscription.introduction" />
);
